import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=5e947ef8&scoped=true&"
import script from "./VSwitch.vue?vue&type=script&lang=js&"
export * from "./VSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e947ef8",
  null
  
)

export default component.exports